import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    spacingContainer: {
      padding: 0,
    },
    forgotPasswordContainer: { margin: '12px 0', padding: '0 8px' },
    descriptionButtonsContainer: { marginTop: 5 },
    login: { marginBottom: 8 },
    titleLogin: { fontFamily: 'Roboto', fontSize: 24 },
    subtitleLogin: { marginBottom: 18, fontSize: 14 },
    button: { height: 50, marginBottom: 10 },
    copyrightWrapper: { marginTop: 46 },
    forgotPasswordLinkContainer: { textAlign: 'right', marginTop: 12 },
    changePasswordContainer: { textAlign: 'left', marginTop: 12 },
    corporateContainer: {
      marginTop: 30,
      justifyContent: 'center',
    },
    checkboxLabel: {
      fontSize: 14,
      letterSpacing: 0,
      lineHeight: 0.25,
      color: '#707070',
    },
    link: {
      color: '#4285f3',
    },
    captcha: {
      '& .grecaptcha-badge': {
        bottom: '70px !important',
      },
    },
  });
